const LUNC = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.996 19.998c5.52 0 9.995-4.475 9.995-9.995S15.516.008 9.996.008.001 4.483.001 10.003s4.475 9.995 9.995 9.995Z"
      fill="#172852"
    />
    <path
      d="M8.052 4.475c1.17-.438 2.488-.439 3.68-.08 1.553.483 2.863 1.654 3.548 3.124.189.419.37.856.388 1.322-.873-.506-1.83-.834-2.788-1.133-1.533-.553-3.138-.936-4.59-1.696-.338-.202-.768-.409-.86-.83-.037-.363.348-.566.622-.707ZM4.519 8.013c.339-.92.894-1.773 1.65-2.406.191 1.578.863 3.104 1.972 4.251 1.33 1.382 3.226 2.231 5.153 2.199.766.024 1.515-.153 2.261-.296-.734 2.655-3.644 4.417-6.34 3.993-1.627-.208-3.129-1.171-4.035-2.532-1.023-1.503-1.28-3.499-.661-5.209Z"
      fill="#FFD83D"
    />
    <path
      d="M12.88 7.708c.958.299 1.914.627 2.787 1.133l.059.03c.08.61.14 1.23.032 1.84-.439-.186-.795-.513-1.166-.802-.716-.596-1.447-1.277-1.713-2.2Z"
      fill="#FF6F03"
    />
  </svg>
);
export default LUNC;
